<mat-form-field
  appearance="fill"
  class="filter-location-form-field mat-form-field w-100"
>
  <mat-label>Location</mat-label>
  <mat-select
    [formControl]="locationFilterFormControl"
    [multiple]="true"
    (selectionChange)="updateLocationFilter()"
    data-cy="location-filter"
  >
    @for (option of locationData; track option) {
    <mat-option [value]="option.value">
      {{ option.label }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>
